import { render, staticRenderFns } from "./baseTest.vue?vue&type=template&id=d00dca32&scoped=true&"
import script from "./baseTest.vue?vue&type=script&lang=js&"
export * from "./baseTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00dca32",
  null
  
)

export default component.exports